import { createSlice } from "@reduxjs/toolkit";
import { ProductPropType } from "./types";

const initialStateValue: ProductPropType = {
  products: [],
  productsLoading: true,
};

export const productSlice = createSlice({
  name: "products",
  initialState: { value: initialStateValue },
  reducers: {
    setProduct: (state, action) => {
      state.value = { ...state.value, ...action.payload };
    },
  },
});

export const { setProduct } = productSlice.actions;
export default productSlice.reducer;
